import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { TID } from "@/constants/testIds";

const ANCHORS = [
  { href: "#checklists", label: "Checklists", tid: "nav-checklists" },
  { href: "#ponto", label: "Ponto", tid: "nav-ponto" },
  { href: "#estoque", label: "Estoque", tid: "nav-estoque" },
  { href: "#depoimentos", label: "Depoimentos", tid: "nav-depoimentos" },
  { href: "#faq", label: "FAQ", tid: "nav-faq" },
  { href: "#roi", label: "ROI", tid: "nav-roi" },
];

export default function LandingNav() {
  return (
    <nav
      data-testid={TID.landingNav}
      className="sticky top-0 z-40 bg-stone-50/90 backdrop-blur-md border-b border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-3.5 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <img src="/logo.png" alt="Ultra" className="h-9 w-9 rounded-lg" />
          <div className="hidden sm:block">
            <div className="font-display text-xl font-extrabold leading-none text-stone-950">Ultra</div>
            <div className="text-[9px] font-bold tracking-[0.25em] text-emerald-800 uppercase mt-0.5">
              Cozinha organizada
            </div>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {ANCHORS.map((a) => (
            <a
              key={a.href}
              href={a.href}
              data-testid={a.tid}
              className="px-3 py-2 rounded-md font-body text-sm text-stone-600 hover:text-stone-950 hover:bg-stone-200/60 transition-colors"
            >
              {a.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          <Link to="/pricing" className="hidden sm:block">
            <Button variant="ghost" className="font-body text-sm" data-testid="nav-pricing">
              Planos
            </Button>
          </Link>
          <Link to="/login">
            <Button variant="ghost" className="font-body text-sm px-3 sm:px-4" data-testid="nav-login">
              Entrar
            </Button>
          </Link>
          <Link to="/register">
            <Button className="bg-emerald-800 hover:bg-emerald-900 text-white font-body px-3 sm:px-4 whitespace-nowrap" data-testid="nav-register">
              Comece grátis
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
